import { Avatar, Badge, Text as ChakraText, Flex, HStack, Icon, Menu, MenuButton, MenuItem, MenuList, createIcon, useBreakpointValue } from '@chakra-ui/react';

import React from 'react'
import { consent } from '../../../js/consent/consent-bootstrap';
import TopNavigationSupportModal from './top-navigation-support-modal';
import TopNavigationUserNotificationsDrawer from './top-navigation-user-notifications-drawer';
import { hexToRGBA } from '../../utils/hexToRGBA';
import { useQuery } from '@tanstack/react-query';

export default function TopNavigationUserMenu(props) {
    const { user, company, accessHelper, application, analyze, authorization, onClose, zendeskWidget, translations } = props;
    
    const { useEffect, useRef, useMemo, useState } = React;
    const isMobile = useBreakpointValue({ base: true, md: false });

    const [notificationsOpen, setNotificationsOpen] = useState(false);
    const [supportModalOpen, setSupportModalOpen] = useState(false);

    const hoverColor =  hexToRGBA(application.theme.colors.brand.primary, 0.1)

    const Star = createIcon({
        displayName: 'Star',
        viewBox: '0 0 24 24',
        d: 'M19.4087 24L12 19.1606L4.5913 24L6.67826 15.0847L0 9.14931L8.71884 8.48435L12 0L15.2812 8.48435L24 9.14931L17.3217 15.0847L19.4087 24ZM12 16.8456L16.5101 19.7886L15.2464 14.3581L19.2928 10.7748L14.0058 10.3684L12 5.1842L9.9942 10.3684L4.70725 10.7748L8.75362 14.3581L7.48986 19.7886L12 16.8456Z',
      });
    
    const AngleDown = createIcon({
        displayName: 'AngleDown',
        viewBox: '0 0 25 16',
        d: 'M23.4574 4.55604L13.556 14.4574C13.3408 14.6726 13.1076 14.8247 12.8565 14.9137C12.6054 15.0027 12.3363 15.0479 12.0493 15.0493C11.7623 15.0493 11.4933 15.0041 11.2421 14.9137C10.991 14.8233 10.7578 14.6712 10.5426 14.4574L0.641243 4.55604C0.246625 4.16142 0.0493159 3.65918 0.0493159 3.04932C0.0493159 2.43945 0.246624 1.93721 0.641243 1.54259C1.03586 1.14797 1.5381 0.950662 2.14797 0.950662C2.75784 0.950662 3.26008 1.14797 3.6547 1.54259L12.0493 9.93721L20.4439 1.54259C20.8386 1.14797 21.3408 0.950661 21.9507 0.950661C22.5605 0.950661 23.0628 1.14797 23.4574 1.54259C23.852 1.93721 24.0493 2.43945 24.0493 3.04932C24.0493 3.65918 23.852 4.16142 23.4574 4.55604Z',
      });
    
    const ExternalLink = createIcon({
        displayName: 'ExternalLink',
        viewBox: '0 0 16 16',
        path: [
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_606_3056)">
              <path
                d="M15.5 0.5L7.5 8.5"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M8.5 0.5H15.5V7.5"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M12.5 9.5V14C12.5 14.3978 12.342 14.7794 12.0607 15.0607C11.7794 15.342 11.3978 15.5 11 15.5H2C1.60218 15.5 1.22064 15.342 0.93934 15.0607C0.658035 14.7794 0.5 14.3978 0.5 14V5C0.5 4.60218 0.658035 4.22064 0.93934 3.93934C1.22064 3.65804 1.60218 3.5 2 3.5H6.5"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_606_3056">
                <rect width="16" height="16" fill="white" />
              </clipPath>
            </defs>
          </svg>,
        ],
      });
    
       const Bell = createIcon({
        displayName: 'Bell',
        viewBox: '0 0 18 18',
        path: [
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_554_3091)">
              <path
                d="M13.5 6.3253V6.0293C13.5 3.5443 11.485 1.5293 9 1.5293C6.515 1.5293 4.5 3.5443 4.5 6.0293V6.3253C4.5 7.7483 3.743 9.0713 2.508 9.7793C1.867 10.1473 1.5 10.5733 1.5 11.0293C1.5 12.4103 4.858 13.5293 9 13.5293C13.142 13.5293 16.5 12.4103 16.5 11.0293C16.5 10.5733 16.133 10.1473 15.492 9.7793C14.257 9.0723 13.5 7.7483 13.5 6.3253Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M11.292 15.0293C10.906 15.9123 10.025 16.5293 9.00001 16.5293C7.97501 16.5293 7.09501 15.9123 6.70801 15.0303"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_554_3091">
                <rect width="18" height="18" fill="white" />
              </clipPath>
            </defs>
          </svg>,
        ],
      });
    
      const UserEdit = createIcon({
        displayName: 'UserEdit',
        viewBox: '0 0 18 18',
        path: [
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_606_3035)">
              <path
                d="M12 16L9.5 16.5L10 14L14.5 9.5L16.5 11.5L12 16Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M8 8C9.79493 8 11.25 6.54493 11.25 4.75C11.25 2.95507 9.79493 1.5 8 1.5C6.20507 1.5 4.75 2.95507 4.75 4.75C4.75 6.54493 6.20507 8 8 8Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M8.9999 10.577C8.6739 10.527 8.3399 10.5 7.9999 10.5C4.5789 10.5 1.7809 13.145 1.5249 16.5H6.4999"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_606_3035">
                <rect width="18" height="18" fill="white" />
              </clipPath>
            </defs>
          </svg>,
        ],
      });
    
      const UserSearch = createIcon({
        displayName: 'UserSearch',
        viewBox: '0 0 18 18',
        path: [
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_595_3129)">
              <path
                d="M12.8887 9.72865C13.7167 9.69685 14.527 9.97854 15.1562 10.5177C15.7854 11.0569 16.1878 11.8138 16.2832 12.6369C16.3719 13.4025 16.1863 14.1714 15.7666 14.8136L17.5293 16.5763L17.5312 16.5792C17.6538 16.7063 17.7222 16.8764 17.7207 17.0529C17.7191 17.2294 17.6483 17.3987 17.5234 17.5236C17.3986 17.6484 17.2293 17.7192 17.0527 17.7208C16.8762 17.7223 16.7061 17.654 16.5791 17.5314L16.5762 17.5294L14.8135 15.7667C14.1713 16.1864 13.4024 16.372 12.6367 16.2833C11.8137 16.1879 11.0568 15.7855 10.5176 15.1564C9.97837 14.5271 9.69667 13.7169 9.72851 12.8888C9.76048 12.0608 10.1035 11.2755 10.6894 10.6896C11.2753 10.1037 12.0607 9.76063 12.8887 9.72865ZM11.085 15.4289C11.1598 15.4887 11.2376 15.5444 11.3174 15.5968C11.1575 15.4916 11.0069 15.3716 10.8682 15.2374L11.085 15.4289ZM13.4033 11.132C13.0287 11.0575 12.64 11.0962 12.2871 11.2423C11.9344 11.3885 11.6331 11.6359 11.4209 11.9533C11.2352 12.2312 11.1252 12.5522 11.1006 12.8839L11.0947 13.0265C11.0953 13.5385 11.2991 14.0296 11.6611 14.3917C12.0232 14.7537 12.5144 14.9575 13.0264 14.9581C13.4082 14.9581 13.7821 14.8451 14.0996 14.633C14.4172 14.4207 14.6653 14.1187 14.8115 13.7658C14.9576 13.4129 14.9954 13.0241 14.9209 12.6496C14.8464 12.2752 14.6623 11.9313 14.3926 11.6613C14.1225 11.3912 13.7779 11.2065 13.4033 11.132ZM16.0986 13.2091C16.104 13.1229 16.1063 13.0362 16.1045 12.9494L16.1035 12.9455C16.1053 13.0336 16.1041 13.1216 16.0986 13.2091ZM10.6348 11.046C10.5781 11.1145 10.5249 11.1853 10.4746 11.258C10.5249 11.1853 10.5781 11.1145 10.6348 11.046ZM15.2207 10.8517L15.0264 10.6691C14.9525 10.6058 14.8758 10.546 14.7969 10.4904C14.718 10.4348 14.6369 10.3829 14.5537 10.3351C14.3871 10.2395 14.2119 10.1607 14.0312 10.0978C14.3923 10.2235 14.73 10.416 15.0254 10.6691C15.0933 10.7273 15.1586 10.7881 15.2207 10.8517ZM12.5059 10.9601C12.4058 10.9853 12.307 11.017 12.2109 11.0568V11.0578C12.3071 11.0179 12.4057 10.9854 12.5059 10.9601ZM15.4189 11.0753C15.3614 11.004 15.3013 10.9345 15.2373 10.8683L15.2334 10.8644C15.2987 10.932 15.3603 11.0027 15.4189 11.0753Z"
                fill="#2D2D2D"
              />
              <path
                d="M7.57895 7.5791C9.2794 7.5791 10.6579 6.20061 10.6579 4.50015C10.6579 2.7997 9.2794 1.4212 7.57895 1.4212C5.87849 1.4212 4.5 2.7997 4.5 4.50015C4.5 6.20061 5.87849 7.5791 7.57895 7.5791Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M9.47377 10.245C8.87693 10.0517 8.2403 9.94753 7.57903 9.94753C4.33809 9.94753 1.68735 12.4533 1.44482 15.6317H9.47377"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_595_3129">
                <rect width="18" height="18" fill="white" />
              </clipPath>
            </defs>
          </svg>,
        ],
      });
    
      const QuestionCircle = createIcon({
        displayName: 'QuestionCircle',
        viewBox: '0 0 18 18',
        path: [
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_554_3111)">
              <path
                d="M9 16.5586C13.1421 16.5586 16.5 13.2007 16.5 9.05859C16.5 4.91646 13.1421 1.55859 9 1.55859C4.85786 1.55859 1.5 4.91646 1.5 9.05859C1.5 13.2007 4.85786 16.5586 9 16.5586Z"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M9.00293 14.0586C9.55521 14.0586 10.0029 13.6109 10.0029 13.0586C10.0029 12.5063 9.55521 12.0586 9.00293 12.0586C8.45065 12.0586 8.00293 12.5063 8.00293 13.0586C8.00293 13.6109 8.45065 14.0586 9.00293 14.0586Z"
                fill="currentColor"
              />
              <path
                d="M7.5 4.95591C8.453 4.09591 10.518 4.11091 10.923 5.59091C11.453 7.51291 9 7.52091 9 10.3789"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_554_3111">
                <rect width="18" height="18" fill="white" />
              </clipPath>
            </defs>
          </svg>,
        ],
      });
    
      const Language = createIcon({
        displayName: 'Language',
        viewBox: '0 0 18 18',
        path: [
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M4.5 5.5V10.5L1.5 15.5H14.5C15.605 15.5 16.5 14.605 16.5 13.5V5.5C16.5 4.395 15.605 3.5 14.5 3.5H6.5C5.395 3.5 4.5 4.395 4.5 5.5Z"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M7.5 6.5H13.5"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M7.5 9.5H13.5"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M7.5 12.5H10.5"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeMiterlimit="10"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>,
        ],
      });
    
      const Qooper = createIcon({
        displayName: 'Qooper',
        viewBox: '0 0 845 949',
        d: 'M720.915 123.898C638.596 40.226 539.389 0 422.207 0C306.111 0 205.842 40.226 123.499 123.898C40.1182 206.48 1.08222 307.07 0.020523 423.562C-1.04118 540.029 39.0812 640.643 122.462 724.291C204.78 806.873 304.012 847.123 422.231 847.123C448.873 847.123 474.526 844.993 499.291 840.782L606.967 948.803L691.977 863.521L574.672 745.84C574.548 745.914 574.425 745.964 574.301 746.038L517.784 689.34C488.131 699.917 456.255 705.218 422.207 705.218C344.11 705.218 277.593 677.699 222.706 623.676C168.88 568.613 140.387 501.908 140.387 422.497C140.387 345.19 168.88 278.486 222.706 223.423C277.593 169.425 344.085 139.775 422.207 139.775C500.303 139.775 566.82 169.425 621.707 223.423C675.533 278.486 704.026 345.19 704.026 422.497C704.026 456.778 706.248 523.532 655.262 571.387L539.882 455.638L454.872 540.921L572.178 658.601L674.965 761.717C698.298 742.125 734.297 712.005 761.95 678.392C775.876 661.475 794.69 625.93 794.69 625.93C828.171 565.195 844.417 498.118 844.417 423.562C844.417 306.005 803.258 206.48 720.915 123.898Z',
      });
    
      const Logout = createIcon({
        displayName: 'Logout',
        viewBox: '0 0 18 18',
        path: [
          <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g clipPath="url(#clip0_554_3142)">
              <path
                d="M7.5376 5.5875V3.15C7.5376 2.76212 7.69168 2.39013 7.96595 2.11586C8.24023 1.84158 8.61222 1.6875 9.0001 1.6875H14.8501C15.238 1.6875 15.61 1.84158 15.8842 2.11586C16.1585 2.39013 16.3126 2.76212 16.3126 3.15V14.85C16.3126 15.2379 16.1585 15.6099 15.8842 15.8841C15.61 16.1584 15.238 16.3125 14.8501 16.3125H9.0001C8.61222 16.3125 8.24023 16.1584 7.96595 15.8841C7.69168 15.6099 7.5376 15.2379 7.5376 14.85V12.4125"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M12.4125 9H1.6875"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M4.6125 6.07544L1.6875 9.00044L4.6125 11.9254"
                stroke="currentColor"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </g>
            <defs>
              <clipPath id="clip0_554_3142">
                <rect width="18" height="18" fill="white" />
              </clipPath>
            </defs>
          </svg>,
        ],
      });

       const CircleCheck = createIcon({
        displayName: 'CircleCheck',
        viewBox: '0 0 16 17',
        path: [
          <svg xmlns="http://www.w3.org/2000/svg" width="16" height="17" viewBox="0 0 16 17" fill="none">
            <g clipPath="url(#clip0_454_5055)">
              <path
                d="M5.69951 7.8C5.29951 7.4 4.69951 7.4 4.29951 7.8C3.89951 8.2 3.89951 8.8 4.29951 9.2L6.29951 11.2C6.49951 11.4 6.69951 11.5 6.99951 11.5C7.29951 11.5 7.49951 11.4 7.69951 11.2L14.6995 4.2C15.0995 3.8 15.0995 3.2 14.6995 2.8C14.2995 2.4 13.6995 2.4 13.2995 2.8L6.99951 9.1L5.69951 7.8Z"
                fill="currentColor"
              />
              <path
                d="M6.99951 16.5C10.8995 16.5 13.9995 13.4 13.9995 9.5C13.9995 8.9 13.5995 8.5 12.9995 8.5C12.3995 8.5 11.9995 8.9 11.9995 9.5C11.9995 12.3 9.79951 14.5 6.99951 14.5C4.19951 14.5 1.99951 12.3 1.99951 9.5C1.99951 6.7 4.19951 4.5 6.99951 4.5C7.59951 4.5 8.09951 4.6 8.69951 4.8C9.19951 5 9.79951 4.7 9.99951 4.2C10.1995 3.7 9.89951 3.1 9.39951 2.9C8.59951 2.6 7.79951 2.5 6.99951 2.5C3.09951 2.5 -0.000488281 5.6 -0.000488281 9.5C-0.000488281 13.4 3.09951 16.5 6.99951 16.5Z"
                fill="currentColor"
              />
            </g>
            <defs>
              <clipPath id="clip0_454_5055">
                <rect width="16" height="16" fill="white" transform="translate(-0.000488281 0.5)" />
              </clipPath>
            </defs>
          </svg>,
        ],
      });

    const logout = () => {
        analyze.record(
            { resource: 'authtokens' },
            { token: authorization.getAuthToken().token, action: 'signout' }
          );

          application.analyticsProvider.trackEvent('signout');
          
        //   $timeout(function () {
            authorization.signout();
        //   }, 1);
    }

    
    const hubLinks = useMemo(() => {
        if (!application?.hubLinks || !Array.isArray(application.hubLinks) || application.hubLinks.length === 0) return [];
    
        return application.hubLinks.map((link) => ({
          label: link.text,
          icon: ExternalLink,
          onClick: () => window.open(link.url, '_blank'),
          render: true,
        }));
      }, [application?.hubLinks]);
    
    const menuListOptions = useMemo(
        () => [
          {
            label: translations?.userMenuNotifications || 'Notifications',
            icon: Bell,
            rightElement:
              Array.isArray(unreadNotifications) && unreadNotifications.length > 0 ? (
                <Badge backgroundColor="red.300" color="white" fontSize="12px" borderRadius="full" minWidth="16px"
                height="16px"
                display="flex"
                alignItems="center"
                justifyContent="center"
                paddingX={1}>
                  {unreadNotifications.length}
                </Badge>
              ) : undefined,
            onClick: () => setNotificationsOpen(true),
            render: true,
          },
          {
            label: translations?.editProfile || 'Edit Profile',
            icon: UserEdit,
            onClick: () => window.location.replace('/profile'),
            render: true,
          },
          {
            label: translations?.peopleSearch || 'People Search',
            icon: UserSearch,
            onClick: () => window.location.replace('/people'),
            render: company?.feature_flags?.enable_explore_search,
          },
          {
            label: translations?.support || 'Support',
            icon: QuestionCircle,
            onClick: () => setSupportModalOpen(true),
            render: true,
          },
          {
            label: translations?.whatsNew || "What's New",
            icon: Star,
            onClick: () =>
              window.open(
                'https://product.continu.com/changelog',
                '_blank',
              ),
            render: company?.feature_flags?.show_whatsnew,
          },
          {
            label: 'Roadmap',
            icon: CircleCheck,
            onClick: () => window.open(`https://product.continu.com/roadmap${user?.email ? `?email=${encodeURIComponent(user.email)}` : ''}`, '_blank'),
            render: true,
          },
          {
            label: translations?.reviewUs || 'Review Us',
            icon: Language,
            onClick: () => window.open('https://www.continu.com/lp/review-us', '_blank'),
            render: company?.feature_flags?.show_referral,
          },
          ...hubLinks,
          {
            label: translations?.qooper || 'Qooper',
            icon: Qooper,
            onClick: () => window.location.replace('/mentor'),
            render: company?.feature_flags?.enable_qooper,
          },
          {
            label: translations?.cookiePreferences || 'Cookie preferences',
            onClick: () => consent.showPreferences(),
            render: consent.isEnabled(),
          },
          {
            label: translations?.logout || 'Logout',
            icon: Logout,
            onClick: () => logout(),
            render: true,
          },
        ],
        [unreadNotifications, company, hubLinks, translations],
      );

    

    

    const getUserNotifications = async (id, archived = false) => {
        if (!authorization) {
          throw new Error('Authorization object is null');
        }

        const authToken = authorization.getAuthToken();
        
        
        const params = new URLSearchParams({
          archived: archived.toString(),
          fields: 'user,company,message,user_from,archived,viewed,createdAt,no_app',
          no_app: '$ne,true',
          page: '1',
          per_page: '200',
          sort: 'createdAt,-1',
          user: id || '',
          'user_from-populate': 'first_name,last_name,full_name,email,image',
        });

        const response = await fetch(`${application.API}/v3/notifications?${params.toString()}`, {
          method: 'GET',
          headers: {
            'authorization': `AuthToken token=${authToken.authtoken}`,
          },
        });

        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
        }

        const data = await response.json();
        return data;
      };

    const { data: unreadNotifications, isLoading, error } = useQuery({
        queryKey: ['notifications', user._id, false],
        queryFn: () => getUserNotifications(user._id, false),
        enabled: !!user?._id && !!authorization, // Only run the query when user._id and authorization exist
      });

      const { data: readNotifications } = useQuery({
        queryKey: ['notifications', user._id, true],
        queryFn: () => getUserNotifications(user._id, true),
        enabled: !!user?._id && !!authorization, // Only run the query when user._id and authorization exist
      });

    

    return (
        <Flex data-testid="user-menu">
      <Menu>
        <MenuButton
          aria-label="User Menu"
          color="#3a3a3a"
          fontSize="14px"
          fontWeight={600}
          padding={4}
          borderRadius="8px"
          _hover={{
            backgroundColor: hoverColor,
          }}
        >
          <HStack spacing={2}>
            <Avatar height="32px" width="32px" name={user?.full_name} src={user?.image} position="relative">
              {Array.isArray(unreadNotifications) && unreadNotifications.length > 0 && (
                <Badge
                  position="absolute"
                  backgroundColor="#FF637E"
                  color="white"
                  zIndex={9999}
                  top={-2}
                  left="60%"
                  borderRadius="full"
                  fontSize="10px"
                  minWidth="16px"
                  height="16px"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  paddingX={1}
                >
                  {unreadNotifications.length}
                </Badge>
              )}
            </Avatar>

            {!isMobile && (
              <>
                <ChakraText margin={0}>{user?.full_name}</ChakraText>

                <AngleDown boxSize={3} />
              </>
            )}
          </HStack>
        </MenuButton>

        <MenuList
          paddingX={2}
          paddingY={4}
          backgroundColor="#fafafa"
          border="1px solid"
          borderColor="#ededed"
          borderRadius="8px"
        >
          {Array.isArray(menuListOptions) && menuListOptions.map((option) => {
            if (!option.render) return null;

            return (
              <MenuItem
                key={option.label}
                fontSize="14px"
                fontWeight={500}
                color="baseBlack"
                backgroundColor="#fafafa"
                paddingX={4}
                paddingY={3}
                borderRadius="8px"
                onClick={option.onClick}
                _hover={{
                  backgroundColor: hoverColor,
                }}
              >
                <HStack spacing={2}>
                  <Icon as={option.icon} boxSize={4} />

                  <ChakraText>{option.label}</ChakraText>

                  {option.rightElement}
                </HStack>
              </MenuItem>
            );
          })}
        </MenuList>
      </Menu>

        <TopNavigationUserNotificationsDrawer
        translations={translations}
        onClose={() => {
          setNotificationsOpen(false);
          onClose();
        }}
        isOpen={notificationsOpen}
        unreadNotifications={unreadNotifications}
        readNotifications={readNotifications}
        application={application}
        authorization={authorization}
      />



      <TopNavigationSupportModal
        onClose={onClose}
        supportModalOpen={supportModalOpen}
        setSupportModalOpen={setSupportModalOpen}
        user={user}
        company={company}
        application={application}
        zendeskWidget={zendeskWidget}
        translations={translations}
      /> 
    </Flex>
    )
}
